<template>
  <Modal :id="'cmp-payment-provider-dialog'" @cancelled="onCancel">
    <template slot="header">{{ ppkey == '' ? 'NEW BANK DETAILS' : $dft.snakeCaseToWords(ppkey) }}</template>

    <template slot="body">
      <div>
        <div class="form-group" v-if="!isEdit">
          <Dropdown
            class="dt-dropdown"
            :options="dropdownItems"
            v-if="dropdownItems && dropdownItems.length > 0"
            :selected="dropdownItems.find(c => c.value === paymentProviderName)"
            :placeholder="'Select payment provider'"
            v-on:selectedChange="e => onDropdownPayment(e)"
            box
            :listHeight="250"
          ></Dropdown>
        </div>
          <ClassicBanking v-if="ppkey == 'classic_banking'" :formsData="ppData" @changed="onFormChange"></ClassicBanking>

          <IbanBanking v-if="ppkey == 'iban_banking'" :formsData="ppData" @changed="onFormChange"></IbanBanking>

          <InternationalBank v-if="ppkey == 'international_bank_infos'" :countries="countries" :formsData="ppData" @changed="onFormChange"></InternationalBank>

          <Paypal v-if="ppkey == 'paypal'" :formsData="ppData" @changed="onFormChange"></Paypal>
      </div>
    </template>

    <template slot="options">
      <!-- <button class="dt-button s6" @click.stop="onDeleteProvider">Delete</button> -->
      <!-- <button class="dt-button s6" @click.stop="onSaveProvider">Save</button> -->
      <div class="ut-flex">
        <div><button class="dt-button s1" @click.stop="onCancel">  {{ $t('cancel') }}</button></div>
        <div><button class="dt-button s1 v1" @click.stop="onSaveProvider">  {{ $t('ok') }}</button></div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";

import { ContactsService } from '../../services/contacts.service';
import ClassicBanking from './classic-banking.vue';
import IbanBanking from './iban-banking.vue';
import Paypal from './paypal.vue';
import InternationalBank from './international-bank.vue';
import { countries } from "../../../../assets/data/countries";
import { ConfirmationService } from '../../../../dt-plugins/confirmation/confirmation.service';

export default {
  props: ["accountingInfo", "paymentProviderTitle", "paymentProviderKey", "isEdit"],
  components: {
    Modal,
    ClassicBanking,
    IbanBanking,
    Paypal,
    InternationalBank
  },
  data() {
    return {
      countries: countries,
      dropdownItems: [
        { text: "Classic Banking", value: "classic_banking" },
        { text: "IBAN Banking", value: "iban_banking" },
        { text: "International Bank Infos", value: "international_bank_infos" },
        { text: "Paypal", value: "paypal" },
      ],      
      selectedPayment: null,
      paymentProviderName: '',
      newPaymentProviderFormData: {},
    }
  },
  async mounted() {
  },
  computed: {    
    paymentProviderForm () {
      return this.accountingInfo.payment_providers[this.ppkey];
    },
    paymentProviderFormData () {
      return this.accountingInfo.payment_provider_data[this.ppkey] || {};
    },
    paymentProviderAlreadyExist () { 
      return Object.keys(this.paymentProviderFormData).length > 0;
    },
    // ...mapGetters(storeNS, {
    //   selectedContact: "selectedContact"
    // }),
    selectedContactId () {
      return this.accountingInfo.contact.contact_id;
    },
    ppkey() {
      return this.isEdit ? this.paymentProviderKey : this.paymentProviderName;
    },
    ppData() {
      return (this.isEdit || this.paymentProviderAlreadyExist) ? this.paymentProviderFormData: this.newPaymentProviderFormData;
    }
  },
  methods: {
    onCancel () {
      this.$emit("cancelled", true);

      this.selectedPayment = null;
      this.paymentProviderName = '';
      this.newPaymentProviderFormData = {};
    },
    onDropdownPayment(e) {
      this.selectedPayment = e;
      this.paymentProviderName = this.selectedPayment.value;
    },
    onFormChange({name, value}) {
      this.$set(this.ppData, name, value);
    },
    onSaveProvider() {
      ContactsService.saveBankDetails(this.selectedContactId, this.ppkey, JSON.stringify(this.ppData));
      this.$emit("create_edit", true);
    },
    // async onDeleteProvider(){
    //   ConfirmationService.create({
    //     subject: 'Delete Payment Provider',
    //     body: ' Do you really want to delete this Bank Details ?',
    //     completed: res => {
    //       switch(res) {
    //         case 'OK': {      
    //             ContactsService.removeBankDetails(this.selectedContactId, this.ppkey).then(res => {
    //             this.$emit("on_delete", true)
    //           });              
    //           break;
    //         }
    //       }
    //     }
    //   });
    // }
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  .dt-dropdown {
    margin: 0 !important;
  }
}

.dt-modal--options {
  .ut-flex {
    width: 100%;
    div {
      flex: 1 0 calc(50% - 20px);
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
      .dt-button {
          width: 100%;
          margin: 0;
      }      
    }
  }
}

</style>